<template>
  <b-sidebar
    id="add-new-contact-sidebar"
    :visible="isAddNewContactSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="val => $emit('update:is-add-new-contact-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New Supplier
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        ref="refFormObserver"
        #default="{invalid}"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="addNewContact"
          @reset.prevent="resetForm"
        >
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group label-for="contactName">
              <template #label>
                Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactName"
                v-model="contactName"
                v-uppercase
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Category -->
          <validation-provider
            #default="validationContext"
            name="Category"
            rules="required"
          >
            <b-form-group label-for="contactCategory">
              <template #label>
                Category <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactCategory"
                v-model="contactCategory"
                v-uppercase
                :state="getValidationState(validationContext)"
                trim
                placeholder="Category"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Type -->
          <validation-provider
            #default="validationContext"
            name="Type"
            rules="required"
          >
            <b-form-group label-for="contactType">
              <template #label>
                Type <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactType"
                v-model="contactType"
                v-uppercase
                :state="getValidationState(validationContext)"
                trim
                placeholder="Type"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Address -->
          <validation-provider
            #default="validationContext"
            name="Address"
            rules="required"
          >
            <b-form-group label-for="contactAddress">
              <template #label>
                Address <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactAddress"
                v-model="contactAddress"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Address"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- City -->
          <validation-provider
            #default="validationContext"
            name="City"
            rules="required"
          >
            <b-form-group label-for="contactCitys">
              <template #label>
                City <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactCitys"
                v-model="contactCity"
                :state="getValidationState(validationContext)"
                trim
                placeholder="City"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Postal Code -->
          <validation-provider
            #default="validationContext"
            name="Postal Code"
            rules="required"
          >
            <b-form-group label-for="contactPostalCode">
              <template #label>
                Postal Code <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactPostalCode"
                v-model="contactPostalCode"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Postal Code"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Phone 1 -->
          <validation-provider
            #default="validationContext"
            name="Phone1"
            rules="required"
          >
            <b-form-group label-for="Phone1">
              <template #label>
                Phone 1 <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Phone1"
                v-model="contactPhone1"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Phone 1"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Phone 2 -->
          <validation-provider
            #default="validationContext"
            name="Phone2"
          >
            <b-form-group
              label="Phone 2"
              label-for="Phone2"
            >
              <b-form-input
                id="Phone2"
                v-model="contactPhone2"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Phone 2"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Fax -->
          <validation-provider
            #default="validationContext"
            name="Fax"
          >
            <b-form-group
              label="Fax"
              label-for="Fax"
            >
              <b-form-input
                id="Fax"
                v-model="contactFax"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Fax"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required"
          >
            <b-form-group label-for="Email">
              <template #label>
                Email <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Email"
                v-model="contactEmail"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- PIC Name -->
          <validation-provider
            #default="validationContext"
            name="PicName"
            rules="required"
          >
            <b-form-group label-for="PicName">
              <template #label>
                PIC Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="PicName"
                v-model="contactPicName"
                :state="getValidationState(validationContext)"
                trim
                placeholder="PIC Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- PIC Phone -->
          <validation-provider
            #default="validationContext"
            name="PicPhone"
            rules="required"
          >
            <b-form-group label-for="PicPhone">
              <template #label>
                PIC Phone <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="PicPhone"
                v-model="contactPicPhone"
                :state="getValidationState(validationContext)"
                trim
                placeholder="PIC Phone"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 1 -->
          <validation-provider
            #default="validationContext"
            name="Bank1"
            rules="required"
          >
            <b-form-group label-for="Bank1">
              <template #label>
                Bank 1 <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Bank1"
                v-model="contactBank1"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 1"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 2 -->
          <validation-provider
            #default="validationContext"
            name="Bank2"
          >
            <b-form-group
              label="Bank 2"
              label-for="Bank2"
            >
              <b-form-input
                id="Bank2"
                v-model="contactBank2"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 2"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 3 -->
          <validation-provider
            #default="validationContext"
            name="Bank3"
          >
            <b-form-group
              label="Bank 3"
              label-for="Bank3"
            >
              <b-form-input
                id="Bank3"
                v-model="contactBank3"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 3"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              block
              :disabled="invalid"
            >
              Add
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="submitButtonDisabled"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewContactSidebarActive',
    event: 'update:is-add-new-contact-sidebar-active',
  },
  props: {
    isAddNewContactSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitButtonDisabled: false,
      required,
      alphaNum,
      contactName: '',
      contactAddress: '',
      contactCity: '',
      contactPostalCode: '',
      contactPhone1: '',
      contactPhone2: '',
      contactFax: '',
      contactEmail: '',
      contactPicName: '',
      contactPicPhone: '',
      contactBank1: '',
      contactBank2: '',
      contactBank3: '',
      contactCategory: '',
      contactType: '',
    }
  },
  setup() {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(() => {})

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  methods: {
    addNewContact() {
      this.submitButtonDisabled = true
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }

      const payload = {
        contact_name: this.contactName,
        contact_address: this.contactAddress,
        contact_category: this.contactCategory,
        contact_type: this.contactType,
        contact_city: this.contactCity,
        contact_postal_code: this.contactPostalCode,
        contact_phone_1: this.contactPhone1,
        contact_phone_2: this.contactPhone2,
        contact_fax: this.contactFax,
        contact_email: this.contactEmail,
        contact_pic_name: this.contactPicName,
        contact_pic_phone: this.contactPicPhone,
        contact_bank_1: this.contactBank1,
        contact_bank_2: this.contactBank2,
        contact_bank_3: this.contactBank3,
        time: moment().format(),
      }

      const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CREATE_CONTACT}`

      axios
        .post(url, payload, { headers })
        .then(response => {
          this.submitButtonDisabled = false
          if (response.data.success === true) {
            this.$root.$emit('refreshTable', 'refreshTable')
            this.isAddNewContactSidebarActive = false

            // Reset fields
            this.contactName = ''
            this.contactAddress = ''
            this.contactCategory = ''
            this.contactType = ''
            this.contactCity = ''
            this.contactPostalCode = ''
            this.contactPhone1 = ''
            this.contactPhone2 = ''
            this.contactFax = ''
            this.contactEmail = ''
            this.contactPicName = ''
            this.contactPicPhone = ''
            this.contactBank1 = ''
            this.contactBank2 = ''
            this.contactBank3 = ''

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Congratulation',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Your data has been inserted!',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          }
        })
        .catch(error => {
          this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              variant: 'danger',
              text: 'Something went wrong',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-contact-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
